import { writable } from 'svelte/store';

let state = {
    isLoggedIn: false,
    accessToken: '',
    user: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
    },
};

let auth = () => {
    const { subscribe, set, update } = writable(state);

    return {
        subscribe,
        login: (token) => {
            return update((store) => ({
                ...store,
                isLoggedIn: true,
                accessToken: token.token,
            }));
        },
        logout: () => {
            return update((store) => ({
                state,
            }));
        },
        refresh: (token) =>
            update(() => ({
                accessToken: token.access,
            })),
        setUser: (user) => {
            return update((store) => ({
                ...store,
                user: {
                    first_name: user.first_name,
                    last_name: user.last_name,
                    email: user.email,
                    mobile: user.mobile,
                },
            }));
        },
        setMobile: (mobile) => {
            return update((store) => ({
                ...store,
                user: {
                    ...store.user,
                    mobile: mobile,
                },
            }));
        },
    };
};

export default auth();
